<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>中期检查</el-breadcrumb-item>
      <el-breadcrumb-item>课题分配</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="projectList">
            <div>
              <span> 课题类别：</span>

              <el-select v-model="projectCategoryName" placeholder="请选择课题类别" @change="getProjectInfo">
                <el-option v-for="item in projectCategorys" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </div>
            <div class="categorySon"> 课题方向：
              <el-select v-model="projectCategoryDirection" @change="changeCategoryDirection" filterable allow-create
                default-first-option placeholder="请选择课题方向">
                <el-option v-for="item in projectCategoryDirections" :key="item.name" :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
            <!-- 课题列表 -->
            <el-table :data="projectInfos" style="margin-top:20px; width: 651px;" border>
              <el-table-column label="分配" width="50">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked" @change="projectChecked(scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="leader_name" label="作者" width="100"></el-table-column>
              <el-table-column prop="name" label="名称" width="300"></el-table-column>
              <el-table-column prop="category_direction" label="课题方向" width="200"></el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="div-assessor">
            <!-- <div>评审专家:</div> -->
            <el-button type="primary" size="small" @click="selectAssessor()" style="margin-top: 20px;">
              选择专家
            </el-button>
            <!-- 专家列表 -->
            <el-table :data="assessorsSelected" style="margin-top:20px; width: 281px" border>
              <el-table-column prop="username" label="姓名" width="280"></el-table-column>
            </el-table>
          </div>

          <!-- 教练员、管理人员 -->
          <div class="div-coach">
            <!-- <div>用户:</div> -->
            <el-button type="primary" size="small" @click="selectCoach()" style="margin-top: 20px;">
              选择用户
            </el-button>
            <el-table :data="coachesSelected" style="margin-top:20px; width: 281px" border>
              <el-table-column prop="username" label="姓名" width="280"></el-table-column>
            </el-table>
          </div>

          <!-- 财务专家 -->
          <div class="div-coach">
            <!-- <div>用户:</div> -->
            <el-button type="primary" size="small" @click="selectFinance()" style="margin-top: 20px;">
              选择财务专家
            </el-button>
            <el-table :data="financesSelected" style="margin-top:20px; width: 281px;" border>
              <el-table-column prop="username" label="姓名" width="280"></el-table-column>
            </el-table>
          </div>

        </el-col>
      </el-row>
      <div class="distributeButton">
        <el-button type="primary" @click="distributeButton">确认分配</el-button>
      </div>
    </el-card>

    <!-- 已分配信息 -->
    <el-card class="distributeTable">
      <el-table :data="projectDistribute" style="width: 100%">
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
              @click="deleteItem(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="leader_name" label="作者" width="120"></el-table-column>
        <el-table-column prop="category_direction" label="课题方向" width="380"></el-table-column>
        <el-table-column prop="pname" label="课题名称" width="580"></el-table-column>
        <el-table-column prop="aname" label="专家姓名" width="120"></el-table-column>
        <el-table-column prop="cname" label="用户名称" width="120"></el-table-column>
        <el-table-column prop="fname" label="财务专家姓名" width="120"></el-table-column>
      </el-table>
    </el-card>

    <!-- 对话框 -->
    <!-- 选择专家对话框 -->
    <el-dialog title="选择专家" :visible.sync="selectAssessorVisible">
      <div class="assessorMajors"> 专家研究方向：
        <el-select v-model="assessorMajor" @change="changeMajor" filterable allow-create default-first-option
          placeholder="请选择课题类别方向">
          <el-option v-for="item in assessorMajors" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <!-- 专家列表 -->
      <el-table :data="assessors" style="width: 500px">
        <el-table-column label="分配" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checked"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="姓名" width="280"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="assessorSelectButton()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 选择教练对话框 -->
    <el-dialog title="选择用户" :visible.sync="selectCoachVisible">
      <!-- 教练列表 -->
      <el-table :data="coaches" style="width: 500px">
        <el-table-column label="分配" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checked"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="姓名" width="280"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="coatchSelectButton()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 选择财务对话框 -->
    <el-dialog title="选择财务专家" :visible.sync="selectFinanceVisible">
      <!-- 教练列表 -->
      <el-table :data="finance_experts" style="width: 500px">
        <el-table-column label="分配" width="80">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checked"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="姓名" width="280"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="financeSelectButton()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      projectCategorys: [],
      projectCategory: {}, //课题类别
      projectCategoryName: '',

      projectCategoryDirections: [],
      projectCategoryDirection: '', //选中的课题方向
      assessors: [], //专家列表
      assessorMajors: ['',], //专家研究方向列表
      assessorMajor: '', //选中的课题方向
      projectInfos: [],
      projectDistribute: [],
      selectAssessorVisible: false, //选择专家对话框
      assessorsSelected: [], //选中的专家

      coaches: [], //教练列表
      selectCoachVisible: false, //选中教练对话框
      coachesSelected: [], //选中的教练员

      // 20230507 财务专家
      finance_experts: [],
      selectFinanceVisible: false,
      financesSelected: [],
    }
  },
  created() {
    this.getProjectCategory()
    this.getAssessors()
    this.getCoaches()
    this.getFinances()
    this.getAssessorMajors()
    this.getProjectDistribute()
  },
  methods: {

    //获取分配列表
    async getProjectDistribute() {
      let res = await this.axios.get('/projectDistribute/?status=中期检查')
      if (res.status == 200) {
        this.projectDistribute = res.data.results
      } else {
        this.$message.warning('获取分配信息失败！')
      }
    },

    //获取课题类别列表
    async getProjectCategory() {
      const res = await this.axios.get(`/projectCategory/`)
      if (res.status === 200) {
        this.projectCategorys = res.data.results
      }
    },

    // 获取课题类型
    async getProjectInfo() {
      // console.log(this.projectCategory)
      const res1 = await this.axios.get(`/projectCategory/?name=${this.projectCategoryName}`)
      if (res1.status === 200) {
        //   console.log(res1.data.results)
        if (res1.data.results.length === 1) {
          this.projectCategory = res1.data.results[0]
          // 给方向下拉框赋值
          this.projectCategoryDirections = this.projectCategory.direction.data
          // 增加一行“所有方向”
          this.projectCategoryDirections.splice(0, 0, {
            name: '所有方向'
          })
          // 获取子类下的课题
          let url = 'projectInfo/?category=' + this.projectCategory.name + '&status=8'
          let resInfo = await this.axios.get(url)
          if (resInfo.status == 200) {
            this.projectInfos = resInfo.data.results
          }
        } else {
          return this.$message.warning("课题类型名称重复")
        }
      } else {
        this.$message.warning("获取类型错误")
      }
    },


    // 课题方向下拉框改变，获取课题列表
    // 获取课题status=8的列表
    async changeCategoryDirection(event) {
      // console.log('event', event)
      if (event == '所有方向') {
        // 选择所有方向
        // status=8
        let url = 'projectInfoLite/?status=8&category=' + this.projectCategoryName
        let resInfo = await this.axios.get(url)
        if (resInfo.status == 200) {
          this.projectInfos = resInfo.data.results
        }
        return
      }
      let url = 'projectInfoLite/?category=' + this.projectCategoryName +
        '&category_direction=' + this.projectCategoryDirection +
        '&status=8'
      let res = await this.axios.get(url)
      if (res.status == 200) {
        this.projectInfos = res.data.results
        // console.log(url)
      }
    },

    //获取专家列表
    async getAssessors() {
      let res = await this.axios.get(`/user/?role_id=3`)
      if (res.status === 200) {
        this.assessors = res.data.results
      } else {
        this.$message.warning("获取专家错误")
      }
    },

    //获取教练员列表
    async getCoaches() {
      let res = await this.axios.get(`/user/?role_id=4`)
      if (res.status === 200) {
        this.coaches = res.data.results
      } else {
        this.$message.warning("获取教练员错误")
      }
    },

    //获取财务专家列表
    async getFinances() {
      let res = await this.axios.get(`/user/?role_id=5`)
      if (res.status === 200) {
        this.finance_experts = res.data.results
      } else {
        this.$message.warning("获取教练员错误")
      }
    },

    // 选择专家按钮，点击显示选择对话框，选择专家
    selectAssessor() {
      this.selectAssessorVisible = true
    },

    // 获取专家研究方向
    async getAssessorMajors() {
      let res = await this.axios.get('/assessorMajor/')
      if (res.status == 200) {
        this.assessorMajors = res.data.results
        // 插入第一条，获取所有专家
        this.assessorMajors.splice(0, 0, {
          id: 0,
          name: '所有方向'
        })
      }
    },

    // 专家方向下拉框改变，获取专家列表
    async changeMajor(e) {
      //获取方向名称，查询专家表
      this.assessors = []
      let major = this.getMajorName(e)
      if (e == 0) {
        major = '' //id=0时查询所有
      }
      let url = '/user/?role_id=3&major=' + major
      let res = await this.axios.get(url)
      if (res.status == 200) {
        this.assessors = res.data.results
      }
    },

    // 获取方向名称，因为专家表中存储的是名称不是id
    getMajorName(id) {
      let name = ''
      this.assessorMajors.forEach(a => {
        if (a.id == id) {
          name = a.name
        }
      })
      return name
    },

    projectChecked(item) {
      // console.log(item)
    },

    // 选择专家对话框确认按钮，初始化外层专家列表
    assessorSelectButton() {
      this.assessorsSelected = []
      for (let j = 0; j < this.assessors.length; j++) {
        if (this.assessors[j].checked) {
          this.assessorsSelected.push(this.assessors[j])
        }
      }
      this.selectAssessorVisible = false
    },

    // 选择教练
    selectCoach() {
      this.selectCoachVisible = true
    },

    //教练对话框，确定按钮，初始化外层列表
    coatchSelectButton() {
      this.coachesSelected = []
      for (let j = 0; j < this.coaches.length; j++) {
        if (this.coaches[j].checked) {
          this.coachesSelected.push(this.coaches[j])
        }
      }
      this.selectCoachVisible = false
    },

    // 选择财务
    selectFinance() {
      this.selectFinanceVisible = true
    },

    //财务对话框，确定按钮，初始化外层列表
    financeSelectButton() {
      this.financesSelected = []
      for (let j = 0; j < this.finance_experts.length; j++) {
        if (this.finance_experts[j].checked) {
          this.financesSelected.push(this.finance_experts[j])
        }
      }
      this.selectFinanceVisible = false
    },

    // 确定按钮
    async distributeButton() {
      for (let i = 0; i < this.projectInfos.length; i++) {
        if (this.projectInfos[i].checked) {
          console.log('projectInfo', this.projectInfos[i])
          // 先删除
          // 20240313 不删除，在增加时判断
          // let resGet = await this.axios.get('/projectDistribute/?status=中期检查&pid=' + this.projectInfos[i].pid)
          // if (resGet.status == 200) {
          //   let dataGet = resGet.data.results
          //   for (let k = 0; k < dataGet.length; k++) {
          //     let resDel = await this.axios.delete('/projectDistribute/' + dataGet[k].id)
          //     if (resDel.status != 204) {
          //       this.$message.warning('删除原数据失败，请稍后再试！')
          //     }
          //   }
          // } else {
          //   this.$message.warning('获取数据失败，请稍后再试！')
          //   break
          // }
          // 写专家
          for (let j = 0; j < this.assessorsSelected.length; j++) {
            let data = {
              pid: this.projectInfos[i].pid,
              pname: this.projectInfos[i].name,
              leader: this.projectInfos[i].leader,
              leader_name: this.projectInfos[i].leader_name,
              category: this.projectInfos[i].category,
              category_direction: this.projectInfos[i].category_direction,
              assessor: this.assessorsSelected[j].userid,
              aname: this.assessorsSelected[j].username,
              status: "中期检查",
              new_pid: this.projectInfos[i].new_pid,
              new_name: this.projectInfos[i].new_name,
            }
            // 有记录，不再重复写
            let resGet = await this.axios.get('/projectDistribute/?pid=' + this.projectInfos[i].pid +
              '&assessor=' + this.assessorsSelected[j].userid + '&status=中期检查')
            if (resGet.data.results.length > 0) {
              continue
            }
            let res = await this.axios.post('/projectDistribute/', data)
            if (res.status != 201) {
              this.$message.warning('分配失败，请稍后再试！')
            }
          }
          // 写教练 coach, cname
          for (let j = 0; j < this.coachesSelected.length; j++) {
            let data = {
              pid: this.projectInfos[i].pid,
              pname: this.projectInfos[i].name,
              leader: this.projectInfos[i].leader,
              leader_name: this.projectInfos[i].leader_name,
              category: this.projectInfos[i].category,
              category_direction: this.projectInfos[i].category_direction,
              coach: this.coachesSelected[j].userid,
              cname: this.coachesSelected[j].username,
              status: "中期检查",
              new_pid: this.projectInfos[i].new_pid,
              new_name: this.projectInfos[i].new_name,
            }
            // 有记录，不再重复写
            let resGet = await this.axios.get('/projectDistribute/?pid=' + this.projectInfos[i].pid +
              '&coach=' + this.coachesSelected[j].userid + '&status=中期检查')
            if (resGet.data.results.length > 0) {
              continue
            }
            let res = await this.axios.post('/projectDistribute/', data)
            if (res.status != 201) {
              this.$message.warning('分配失败，请稍后再试！')
            }
          }
          // 写财务 finance_expert, fname
          for (let j = 0; j < this.financesSelected.length; j++) {
            let data = {
              pid: this.projectInfos[i].pid,
              pname: this.projectInfos[i].name,
              leader: this.projectInfos[i].leader,
              leader_name: this.projectInfos[i].leader_name,
              category: this.projectInfos[i].category,
              category_direction: this.projectInfos[i].category_direction,
              finance_expert: this.financesSelected[j].userid,
              fname: this.financesSelected[j].username,
              status: '中期检查',
              new_pid: this.projectInfos[i].new_pid,
              new_name: this.projectInfos[i].new_name,
            }
            // 有记录，不再重复写
            let resGet = await this.axios.get('/projectDistribute/?pid=' + this.projectInfos[i].pid +
              '&finance_expert=' + this.financesSelected[j].userid + '&status=中期检查')
            if (resGet.data.results.length > 0) {
              continue
            }
            let res = await this.axios.post('/projectDistribute/', data)
            if (res.status != 201) {
              this.$message.warning('分配失败，请稍后再试！')
            }
          }
        }
      }
      this.$message.success('分配成功！')
      this.getProjectDistribute()
    },

    // 删除
    async deleteItem(row) {
      // console.log('delete:', row)
      let resDel = await this.axios.delete('/projectDistribute/' + row.id)
      if (resDel.status == 204) {
        this.$message.success('删除成功！')
      }
      this.getProjectDistribute()
    }
  }
}

</script>

<style lang='less'>
.el-breadcrumb {
  margin-bottom: 20px;
}

.categorySon {
  margin-top: 20px;
}

.assessorMajors {
  margin-top: 20px;
}

.distributeButton {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.distributeTable {
  margin-top: 10px;
}

.projectList {
  // border-right: 1px solid #999999;
}

.div-assessor {
  margin-top: 45px;
}

.div-coach {
  // border-top: 1px solid #999999;
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/middleCheck/MiddleCheckDistribute.vue